(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-transition-group"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-transition-group"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("react-transition-group")) : factory(root["react"], root["react-transition-group"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(4)();
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(5);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Accordion", function() { return /* reexport */ accordion; });
__webpack_require__.d(__webpack_exports__, "Alert", function() { return /* reexport */ alert_alert; });
__webpack_require__.d(__webpack_exports__, "Autocomplete", function() { return /* reexport */ autocomplete; });
__webpack_require__.d(__webpack_exports__, "Button", function() { return /* reexport */ Button; });
__webpack_require__.d(__webpack_exports__, "LinkButton", function() { return /* reexport */ LinkButton; });
__webpack_require__.d(__webpack_exports__, "Card", function() { return /* reexport */ card; });
__webpack_require__.d(__webpack_exports__, "Checkbox", function() { return /* reexport */ checkbox_checkbox; });
__webpack_require__.d(__webpack_exports__, "Filter", function() { return /* reexport */ filter; });
__webpack_require__.d(__webpack_exports__, "HorizontalRule", function() { return /* reexport */ horizontal_rule; });
__webpack_require__.d(__webpack_exports__, "Input", function() { return /* reexport */ input; });
__webpack_require__.d(__webpack_exports__, "List", function() { return /* reexport */ list_List; });
__webpack_require__.d(__webpack_exports__, "ListItem", function() { return /* reexport */ list_ListItem; });
__webpack_require__.d(__webpack_exports__, "Menu", function() { return /* reexport */ menu; });
__webpack_require__.d(__webpack_exports__, "Modal", function() { return /* reexport */ modal; });
__webpack_require__.d(__webpack_exports__, "Overlay", function() { return /* reexport */ overlay; });
__webpack_require__.d(__webpack_exports__, "Popup", function() { return /* reexport */ popup; });
__webpack_require__.d(__webpack_exports__, "Radio", function() { return /* reexport */ radio_radio; });
__webpack_require__.d(__webpack_exports__, "RadioButton", function() { return /* reexport */ radio_button; });
__webpack_require__.d(__webpack_exports__, "Select", function() { return /* reexport */ select_select; });
__webpack_require__.d(__webpack_exports__, "Spinner", function() { return /* reexport */ spinner; });
__webpack_require__.d(__webpack_exports__, "Switch", function() { return /* reexport */ switch_switch; });
__webpack_require__.d(__webpack_exports__, "Tag", function() { return /* reexport */ tag; });
__webpack_require__.d(__webpack_exports__, "Tile", function() { return /* reexport */ tile; });
__webpack_require__.d(__webpack_exports__, "Toggle", function() { return /* reexport */ toggle; });
__webpack_require__.d(__webpack_exports__, "Tooltip", function() { return /* reexport */ tooltip; });

// CONCATENATED MODULE: ./src/scss/main.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(0);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(2);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/components/accordion/accordion.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/accordion/accordion.js
var _excluded = ["arrowColorOverride", "children", "className", "isExpanded", "isMinimal", "header", "id"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var accordion_Accordion = function Accordion(props) {
  var arrowColorOverride = props.arrowColorOverride,
    children = props.children,
    className = props.className,
    isDefaultExpanded = props.isExpanded,
    isMinimal = props.isMinimal,
    header = props.header,
    id = props.id,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState = Object(external_react_["useState"])(isDefaultExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = Object(external_react_["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var buttonId = "".concat(id, "-button");
  var contentId = "".concat(id, "-content");
  var componentClassName = classnames_default()('uhc-accordion', {
    'uhc-accordion--expanded': isExpanded,
    'uhc-accordion--focused': focused,
    'uhc-accordion--minimal': isMinimal
  }, className);
  var handleBlur = function handleBlur() {
    setFocused(false);
  };
  var handleClick = function handleClick() {
    setIsExpanded(function (prev) {
      return !prev;
    });
  };
  var handleFocus = function handleFocus() {
    setFocused(true);
  };
  var handleKeyUp = function handleKeyUp(event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      setIsExpanded(function (prev) {
        return !prev;
      });
    }
  };
  return /*#__PURE__*/external_react_default.a.createElement("div", _extends({
    className: componentClassName
  }, rest), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-accordion__header",
    id: buttonId,
    role: "button",
    tabIndex: 0,
    "aria-controls": contentId,
    "aria-disabled": "false",
    "aria-expanded": isExpanded,
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyUp: handleKeyUp
  }, header, /*#__PURE__*/external_react_default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "uhc-accordion__arrow",
    focusable: "false",
    viewBox: "0 0 34 34",
    version: "1.1",
    width: "34px",
    height: "34px",
    "aria-hidden": "true"
  }, /*#__PURE__*/external_react_default.a.createElement("g", {
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1.000000, 1.000000)",
    strokeWidth: "2"
  }, /*#__PURE__*/external_react_default.a.createElement("circle", {
    className: "focus-ring",
    stroke: arrowColorOverride || '#D8D8D8',
    cx: "16",
    cy: "16",
    r: "16"
  }), /*#__PURE__*/external_react_default.a.createElement("g", {
    transform: "translate(12.000000, 15.000000)",
    fillRule: "nonzero",
    stroke: arrowColorOverride || '#196ECF',
    strokeLinecap: "round"
  }, /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M4,4 L8,0 M4,4 L0,0"
  }))))), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-accordion__content",
    hidden: !isExpanded,
    id: contentId,
    role: "region",
    "aria-labelledby": buttonId
  }, children));
};
accordion_Accordion.propTypes = {
  arrowColorOverride: prop_types_default.a.string,
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  header: prop_types_default.a.node,
  id: prop_types_default.a.string,
  isExpanded: prop_types_default.a.bool,
  isMinimal: prop_types_default.a.bool
};
accordion_Accordion.defaultProps = {
  isExpanded: false,
  isMinimal: false
};
/* harmony default export */ var accordion = (accordion_Accordion);
// CONCATENATED MODULE: ./src/components/alert/alert.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/alert/alert.js
var alert_excluded = ["children", "className", "hasArrow"];
function alert_extends() { alert_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return alert_extends.apply(this, arguments); }
function alert_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = alert_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function alert_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var alert_Alert = function Alert(props) {
  var children = props.children,
    className = props.className,
    hasArrow = props.hasArrow,
    rest = alert_objectWithoutProperties(props, alert_excluded);
  var componentClassName = classnames_default()('uhc-alert', {
    'uhc-alert--arrow': hasArrow
  }, className);
  return /*#__PURE__*/external_react_default.a.createElement("div", alert_extends({
    className: componentClassName,
    role: "alert"
  }, rest), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "alert__content"
  }, children));
};
alert_Alert.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  hasArrow: prop_types_default.a.bool
};
alert_Alert.defaultProps = {
  hasArrow: false
};
/* harmony default export */ var alert_alert = (alert_Alert);
// CONCATENATED MODULE: ./src/components/input/input.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/input/input.js
var input_excluded = ["className", "disabled", "id", "isBlock", "isIFTA", "isInvalid", "label", "placeholder", "size", "type", "onBlur", "onChange", "onFocus"];
function input_extends() { input_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return input_extends.apply(this, arguments); }
function input_slicedToArray(arr, i) { return input_arrayWithHoles(arr) || input_iterableToArrayLimit(arr, i) || input_unsupportedIterableToArray(arr, i) || input_nonIterableRest(); }
function input_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function input_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return input_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return input_arrayLikeToArray(o, minLen); }
function input_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function input_iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function input_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function input_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = input_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function input_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Input = /*#__PURE__*/Object(external_react_["forwardRef"])(function (props, ref) {
  var className = props.className,
    disabled = props.disabled,
    id = props.id,
    isBlock = props.isBlock,
    isIFTA = props.isIFTA,
    isInvalid = props.isInvalid,
    label = props.label,
    placeholder = props.placeholder,
    size = props.size,
    type = props.type,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    rest = input_objectWithoutProperties(props, input_excluded);
  var _useState = Object(external_react_["useState"])(false),
    _useState2 = input_slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var _useState3 = Object(external_react_["useState"])(!!props.defaultValue || !!props.value),
    _useState4 = input_slicedToArray(_useState3, 2),
    hasValue = _useState4[0],
    setHasValue = _useState4[1];
  var componentClassName = classnames_default()('uhc-input', {
    'uhc-input--disabled': disabled,
    'uhc-input--block': isBlock,
    'uhc-input--focused': isFocused,
    'uhc-input--ifta': isIFTA,
    'uhc-input--invalid': isInvalid,
    'uhc-input--large': size === 'large',
    'uhc-input--value': hasValue || placeholder || type === 'date'
  }, className);
  var handleFocus = function handleFocus(event) {
    if (typeof onFocus === 'function') {
      onFocus(event);
    }
    setIsFocused(true);
  };
  var handleBlur = function handleBlur(event) {
    if (typeof onBlur === 'function') {
      onBlur(event);
    }
    setIsFocused(false);
  };
  var handleChange = function handleChange(event) {
    if (typeof onChange === 'function') {
      onChange(event);
    }
    setHasValue(!!event.target.value);
  };
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: componentClassName
  }, isIFTA && /*#__PURE__*/external_react_default.a.createElement("label", {
    className: "uhc-input__label",
    htmlFor: id
  }, label), /*#__PURE__*/external_react_default.a.createElement("input", input_extends({
    className: "uhc-input__input",
    disabled: disabled,
    id: id,
    placeholder: placeholder,
    ref: ref,
    type: type,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }, rest)));
});
Input.displayName = 'Input';
Input.propTypes = {
  className: prop_types_default.a.string,
  defaultValue: prop_types_default.a.string,
  disabled: prop_types_default.a.bool,
  id: prop_types_default.a.string,
  isBlock: prop_types_default.a.bool,
  isIFTA: prop_types_default.a.bool,
  isInvalid: prop_types_default.a.bool,
  label: prop_types_default.a.string,
  placeholder: prop_types_default.a.string,
  size: prop_types_default.a.oneOf(['default', 'large']),
  type: prop_types_default.a.string,
  value: prop_types_default.a.string,
  onBlur: prop_types_default.a.func,
  onChange: prop_types_default.a.func,
  onFocus: prop_types_default.a.func
};
Input.defaultProps = {
  disabled: false,
  isBlock: false,
  isIFTA: false,
  isInvalid: false,
  size: 'default',
  type: 'text'
};
/* harmony default export */ var input = (Input);
// CONCATENATED MODULE: ./src/hooks/useEventListener.js

function useEventListener(eventName, handler) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  var savedHandler = Object(external_react_["useRef"])(null);
  Object(external_react_["useEffect"])(function () {
    savedHandler.current = handler;
  }, [handler]);
  Object(external_react_["useEffect"])(function () {
    var isSupported = element && element.addEventListener;
    if (!isSupported) return;
    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };
    element.addEventListener(eventName, eventListener);
    return function () {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
}
// CONCATENATED MODULE: ./src/components/autocomplete/autocomplete.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/autocomplete/autocomplete.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var autocomplete_excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["containerStyle", "items", "isBlock", "isIFTA", "label", "maxItems", "size", "onChange", "onItemSelect", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function autocomplete_slicedToArray(arr, i) { return autocomplete_arrayWithHoles(arr) || autocomplete_iterableToArrayLimit(arr, i) || autocomplete_unsupportedIterableToArray(arr, i) || autocomplete_nonIterableRest(); }
function autocomplete_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function autocomplete_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return autocomplete_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return autocomplete_arrayLikeToArray(o, minLen); }
function autocomplete_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function autocomplete_iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function autocomplete_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function autocomplete_extends() { autocomplete_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return autocomplete_extends.apply(this, arguments); }
function autocomplete_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = autocomplete_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function autocomplete_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var autocomplete_AutocompleteMenu = function AutocompleteMenu(props) {
  var children = props.children,
    rest = autocomplete_objectWithoutProperties(props, autocomplete_excluded);
  return /*#__PURE__*/external_react_default.a.createElement("div", autocomplete_extends({
    className: "uhc-autocomplete__menu",
    role: "listbox"
  }, rest), children);
};
autocomplete_AutocompleteMenu.propTypes = {
  children: prop_types_default.a.node
};
var autocomplete_AutocompleteMenuItem = function AutocompleteMenuItem(props) {
  var children = props.children,
    rest = autocomplete_objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/external_react_default.a.createElement("div", autocomplete_extends({
    className: "uhc-autocomplete__menu-item",
    role: "option",
    tabIndex: 0
  }, rest), children);
};
autocomplete_AutocompleteMenuItem.propTypes = {
  children: prop_types_default.a.node
};
var autocomplete_Autocomplete = function Autocomplete(props) {
  var containerStyle = props.containerStyle,
    items = props.items,
    isBlock = props.isBlock,
    isIFTA = props.isIFTA,
    label = props.label,
    maxItems = props.maxItems,
    size = props.size,
    onChange = props.onChange,
    onItemSelect = props.onItemSelect,
    value = props.value,
    rest = autocomplete_objectWithoutProperties(props, _excluded3);
  var inputRef = Object(external_react_["useRef"])(null);
  var _useState = Object(external_react_["useState"])([]),
    _useState2 = autocomplete_slicedToArray(_useState, 2),
    filteredItems = _useState2[0],
    setFilteredItems = _useState2[1];
  var _useState3 = Object(external_react_["useState"])(false),
    _useState4 = autocomplete_slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = Object(external_react_["useState"])(0),
    _useState6 = autocomplete_slicedToArray(_useState5, 2),
    selectedItemIndex = _useState6[0],
    setSelectedItemIndex = _useState6[1];
  var componentClassName = classnames_default()('uhc-autocomplete', {
    'uhc-autocomplete--block': isBlock
  });
  var formatLabel = function formatLabel(label, inputValue) {
    var formattedLabel = label.replace(new RegExp(inputValue, 'gi'), function (match) {
      return "<span class=\"text-regular\">".concat(match, "</span>");
    });
    return formattedLabel;
  };
  var filterItems = Object(external_react_["useCallback"])(function (inputValue) {
    var newFilteredItems = items.filter(function (item) {
      return item.label.toLowerCase().includes(inputValue.toLowerCase());
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        formattedLabel: formatLabel(item.label, inputValue)
      });
    }).slice(0, maxItems);
    setFilteredItems(newFilteredItems);
  }, [items, maxItems]);
  var handleBlur = function handleBlur() {
    setSelectedItemIndex(null);
    setFocused(false);
  };
  Object(external_react_["useEffect"])(function () {
    filterItems(value);
  }, [filterItems, value]);
  var handleClick = function handleClick(event, item) {
    handleItemSelect(event, item);
  };
  var handleFocus = function handleFocus(event) {
    filterItems(event.target.value);
    setFocused(true);
  };
  var handleItemSelect = Object(external_react_["useCallback"])(function (event, item) {
    onItemSelect(item);
    if (item) {
      inputRef.current.blur();
    }
  }, [onItemSelect]);
  var handleMouseDown = function handleMouseDown(event) {
    event.preventDefault();
  };
  var handleKeyDown = Object(external_react_["useCallback"])(function (event) {
    if (event.keyCode === 13 && focused) {
      event.preventDefault();
      handleItemSelect(event, filteredItems[selectedItemIndex]);
    } else if (event.keyCode === 38 && focused) {
      event.preventDefault();
      if (selectedItemIndex === null || selectedItemIndex === 0) {
        setSelectedItemIndex(filteredItems.length - 1);
      } else {
        if (selectedItemIndex > 0) {
          setSelectedItemIndex(selectedItemIndex - 1);
        }
      }
    } else if (event.keyCode === 40 && focused) {
      event.preventDefault();
      if (selectedItemIndex === null) {
        setSelectedItemIndex(0);
      } else {
        if (selectedItemIndex >= 0 && selectedItemIndex < filteredItems.length - 1) {
          setSelectedItemIndex(selectedItemIndex + 1);
        } else {
          setSelectedItemIndex(0);
        }
      }
    }
  }, [filteredItems, focused, handleItemSelect, selectedItemIndex]);
  useEventListener('keydown', handleKeyDown);
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/external_react_default.a.createElement(input, autocomplete_extends({
    autoComplete: "off",
    ref: inputRef,
    isBlock: isBlock,
    isIFTA: isIFTA,
    label: label,
    size: size,
    type: "search",
    value: value,
    "aria-autocomplete": "both",
    onBlur: handleBlur,
    onChange: onChange,
    onFocus: handleFocus
  }, rest)), value && focused && value.length > 2 && /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-autocomplete__container",
    style: containerStyle
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-autocomplete__popover"
  }, /*#__PURE__*/external_react_default.a.createElement(autocomplete_AutocompleteMenu, null, filteredItems.map(function (item, index) {
    return /*#__PURE__*/external_react_default.a.createElement(autocomplete_AutocompleteMenuItem, {
      key: index,
      "aria-selected": selectedItemIndex === index,
      onClick: function onClick(event) {
        return handleClick(event, item);
      },
      onMouseDown: handleMouseDown
    }, /*#__PURE__*/external_react_default.a.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.formattedLabel
      }
    }));
  })))));
};
autocomplete_Autocomplete.propTypes = {
  containerStyle: prop_types_default.a.object,
  items: prop_types_default.a.array,
  isBlock: prop_types_default.a.bool,
  isIFTA: prop_types_default.a.bool,
  label: prop_types_default.a.string,
  maxItems: prop_types_default.a.number,
  size: prop_types_default.a.oneOf(['default', 'large']),
  onChange: prop_types_default.a.func,
  onItemSelect: prop_types_default.a.func,
  value: prop_types_default.a.string
};
autocomplete_Autocomplete.defaultProps = {
  items: [],
  isBlock: false,
  isIFTA: false,
  maxItems: 5
};
/* harmony default export */ var autocomplete = (autocomplete_Autocomplete);
// CONCATENATED MODULE: ./src/components/button/button.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/button/button.js
var button_excluded = ["children", "className", "isBlock", "isOutlined", "isSecondary"],
  button_excluded2 = ["as", "children", "className", "hasUnderline"];
function button_extends() { button_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return button_extends.apply(this, arguments); }
function button_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = button_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function button_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





/**
 * Primary UI component for user interaction.
 */
var Button = /*#__PURE__*/Object(external_react_["forwardRef"])(function (props, ref) {
  var children = props.children,
    className = props.className,
    isBlock = props.isBlock,
    isOutlined = props.isOutlined,
    isSecondary = props.isSecondary,
    rest = button_objectWithoutProperties(props, button_excluded);
  var componentClassName = classnames_default()('uhc-button', {
    'uhc-button--block': isBlock,
    'uhc-button--outlined': isOutlined,
    'uhc-button--secondary': isSecondary
  }, className);
  return /*#__PURE__*/external_react_default.a.createElement("button", button_extends({
    className: componentClassName,
    ref: ref
  }, rest), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-button__text"
  }, children));
});
Button.displayName = 'Button';
Button.propTypes = {
  /**
   * Is this the principal call to action on the page?
   */
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  isBlock: prop_types_default.a.bool,
  isOutlined: prop_types_default.a.bool,
  isSecondary: prop_types_default.a.bool,
  /**
   * Optional click handler
   */
  onClick: prop_types_default.a.func
};
Button.defaultProps = {
  isBlock: false,
  isOutlined: false,
  isSecondary: false
};
var LinkButton = /*#__PURE__*/Object(external_react_["forwardRef"])(function (props, ref) {
  var as = props.as,
    children = props.children,
    className = props.className,
    hasUnderline = props.hasUnderline,
    rest = button_objectWithoutProperties(props, button_excluded2);
  var Component = as ? as : 'a';
  var componentClassName = classnames_default()('uhc-link-button', {
    'uhc-link-button--underlined': hasUnderline
  }, className);
  return /*#__PURE__*/external_react_default.a.createElement(Component, button_extends({
    className: componentClassName,
    ref: ref,
    tabIndex: "0"
  }, rest), children);
});
LinkButton.propTypes = {
  as: prop_types_default.a.any,
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  hasUnderline: prop_types_default.a.bool
};
LinkButton.defaultProps = {
  hasUnderline: false
};
LinkButton.displayName = 'LinkButton';
// CONCATENATED MODULE: ./src/components/card/card.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/card/card.js
var card_excluded = ["children", "className", "header"];
function card_extends() { card_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return card_extends.apply(this, arguments); }
function card_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = card_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function card_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var card_Card = function Card(props) {
  var children = props.children,
    className = props.className,
    header = props.header,
    rest = card_objectWithoutProperties(props, card_excluded);
  var componentClassName = classnames_default()('uhc-card', className);
  return /*#__PURE__*/external_react_default.a.createElement("div", card_extends({
    className: componentClassName
  }, rest), header && /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-card__header"
  }, header), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-card__content"
  }, children));
};
card_Card.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  header: prop_types_default.a.node
};
/* harmony default export */ var card = (card_Card);
// CONCATENATED MODULE: ./src/components/checkbox/checkbox.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/checkbox/checkbox.js
var checkbox_excluded = ["className", "isAlignTop", "label"];
function checkbox_extends() { checkbox_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkbox_extends.apply(this, arguments); }
function checkbox_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = checkbox_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function checkbox_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var checkbox_Checkbox = function Checkbox(props) {
  var className = props.className,
    isAlignTop = props.isAlignTop,
    label = props.label,
    rest = checkbox_objectWithoutProperties(props, checkbox_excluded);
  var componentClassName = classnames_default()('uhc-checkbox', {
    'uhc-checkbox--align-top': isAlignTop
  }, className);
  return /*#__PURE__*/external_react_default.a.createElement("label", {
    className: componentClassName
  }, /*#__PURE__*/external_react_default.a.createElement("input", checkbox_extends({
    className: "uhc-checkbox__input",
    type: "checkbox"
  }, rest)), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-checkbox__visual"
  }), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-checkbox__label"
  }, label));
};
checkbox_Checkbox.propTypes = {
  className: prop_types_default.a.string,
  isAlignTop: prop_types_default.a.bool,
  label: prop_types_default.a.any
};
checkbox_Checkbox.defaultProps = {
  isAlignTop: false
};
/* harmony default export */ var checkbox_checkbox = (checkbox_Checkbox);
// CONCATENATED MODULE: ./src/components/filter/filter.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/filter/filter.js
var filter_excluded = ["children", "className", "isSelected"];
function filter_extends() { filter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return filter_extends.apply(this, arguments); }
function filter_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = filter_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function filter_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var filter_Filter = function Filter(props) {
  var children = props.children,
    className = props.className,
    isSelected = props.isSelected,
    rest = filter_objectWithoutProperties(props, filter_excluded);
  var componentClassName = classnames_default()('uhc-filter', {
    'uhc-filter--selected': isSelected
  }, className);
  return /*#__PURE__*/external_react_default.a.createElement("label", {
    className: componentClassName
  }, /*#__PURE__*/external_react_default.a.createElement("input", filter_extends({
    className: "uhc-filter__input",
    type: "radio",
    checked: isSelected
  }, rest)), /*#__PURE__*/external_react_default.a.createElement("span", null, children));
};
filter_Filter.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  isSelected: prop_types_default.a.bool
};
filter_Filter.defaultProps = {
  isSelected: false
};
/* harmony default export */ var filter = (filter_Filter);
// CONCATENATED MODULE: ./src/components/horizontal-rule/horizontal-rule.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/horizontal-rule/horizontal-rule.js
var horizontal_rule_excluded = ["className", "isNarrow"];
function horizontal_rule_extends() { horizontal_rule_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return horizontal_rule_extends.apply(this, arguments); }
function horizontal_rule_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = horizontal_rule_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function horizontal_rule_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var horizontal_rule_HorizontalRule = function HorizontalRule(props) {
  var className = props.className,
    isNarrow = props.isNarrow,
    rest = horizontal_rule_objectWithoutProperties(props, horizontal_rule_excluded);
  var componentClassName = classnames_default()('uhc-hr', {
    'uhc-hr--narrow': isNarrow
  }, className);
  return /*#__PURE__*/external_react_default.a.createElement("hr", horizontal_rule_extends({
    className: componentClassName
  }, rest));
};
horizontal_rule_HorizontalRule.propTypes = {
  className: prop_types_default.a.string,
  isNarrow: prop_types_default.a.bool
};
horizontal_rule_HorizontalRule.defaultProps = {
  isNarrow: false
};
/* harmony default export */ var horizontal_rule = (horizontal_rule_HorizontalRule);
// CONCATENATED MODULE: ./src/components/list/list.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/list/list.js
var list_excluded = ["children", "className"],
  list_excluded2 = ["children", "className", "hasAccent"];
function list_extends() { list_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return list_extends.apply(this, arguments); }
function list_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = list_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function list_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var list_ListItem = function ListItem(props) {
  var children = props.children,
    className = props.className,
    rest = list_objectWithoutProperties(props, list_excluded);
  var componentClassName = classnames_default()('uhc-list__item', className);
  return /*#__PURE__*/external_react_default.a.createElement("div", list_extends({
    className: componentClassName
  }, rest), children);
};
list_ListItem.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string
};
var list_List = function List(props) {
  var children = props.children,
    className = props.className,
    hasAccent = props.hasAccent,
    rest = list_objectWithoutProperties(props, list_excluded2);
  var componentClassName = classnames_default()('uhc-list', {
    'uhc-list--accent': hasAccent
  }, className);
  return /*#__PURE__*/external_react_default.a.createElement("div", list_extends({
    className: componentClassName
  }, rest), children);
};
list_List.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  hasAccent: prop_types_default.a.bool
};
list_List.defaultProps = {
  hasAccent: false
};

// CONCATENATED MODULE: ./src/components/menu/menu.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/menu/menu.js
var menu_excluded = ["buttonClassName", "className", "disabled", "id", "isBorderless", "items", "label", "position", "onItemSelect"];
function menu_extends() { menu_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }
function menu_slicedToArray(arr, i) { return menu_arrayWithHoles(arr) || menu_iterableToArrayLimit(arr, i) || menu_unsupportedIterableToArray(arr, i) || menu_nonIterableRest(); }
function menu_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function menu_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return menu_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return menu_arrayLikeToArray(o, minLen); }
function menu_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function menu_iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function menu_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function menu_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = menu_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function menu_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var menu_Menu = function Menu(props) {
  var buttonClassName = props.buttonClassName,
    className = props.className,
    disabled = props.disabled,
    id = props.id,
    isBorderless = props.isBorderless,
    items = props.items,
    label = props.label,
    position = props.position,
    onItemSelect = props.onItemSelect,
    rest = menu_objectWithoutProperties(props, menu_excluded);
  var componentClassName = classnames_default()('uhc-menu', {
    'uhc-menu--borderless': isBorderless,
    'uhc-menu--left': position === 'left',
    'uhc-menu--right': position === 'right'
  }, className);
  var componentButtonClassName = classnames_default()('uhc-menu__button', {
    'uhc-menu__button--borderless': isBorderless
  }, buttonClassName);
  var menuButtonId = "".concat(id, "_button");
  var menuButtonRef = Object(external_react_["useRef"])(null);
  var menuListRef = Object(external_react_["useRef"])(null);
  var _useState = Object(external_react_["useState"])(false),
    _useState2 = menu_slicedToArray(_useState, 2),
    isMenuShown = _useState2[0],
    setIsMenuShown = _useState2[1];
  var _useState3 = Object(external_react_["useState"])(null),
    _useState4 = menu_slicedToArray(_useState3, 2),
    selectedItemIndex = _useState4[0],
    setSelectedItemIndex = _useState4[1];
  Object(external_react_["useEffect"])(function () {
    var keyDownHandler = function keyDownHandler(event) {
      if (!isMenuShown) return;
      switch (event.keyCode) {
        case 27:
          event.stopPropagation();
          event.preventDefault();
          setSelectedItemIndex(null);
          setIsMenuShown(false);
          break;
        case 38:
          event.stopPropagation();
          event.preventDefault();
          if (selectedItemIndex === null || selectedItemIndex === 0) {
            setSelectedItemIndex(items.length - 1);
          } else {
            if (selectedItemIndex > 0) {
              setSelectedItemIndex(selectedItemIndex - 1);
            }
          }
          break;
        case 40:
          event.stopPropagation();
          event.preventDefault();
          if (selectedItemIndex === null) {
            setSelectedItemIndex(0);
          } else {
            if (selectedItemIndex >= 0 && selectedItemIndex < items.length - 1) {
              setSelectedItemIndex(selectedItemIndex + 1);
            } else {
              setSelectedItemIndex(0);
            }
          }
          break;
        case 13:
          event.stopPropagation();
          event.preventDefault();
          handleItemSelect(event, items[selectedItemIndex]);
          break;
        default:
          break;
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return function () {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [isMenuShown, items, onItemSelect, selectedItemIndex]);
  var handleBlur = function handleBlur() {
    setIsMenuShown(false);
    setSelectedItemIndex(null);
  };
  var handleClick = function handleClick() {
    setIsMenuShown(true);
  };
  var handleItemMouseDown = function handleItemMouseDown(event) {
    event.preventDefault();
  };
  var handleItemSelect = function handleItemSelect(event, item) {
    onItemSelect(item);
    setIsMenuShown(false);
    setSelectedItemIndex(null);
  };
  return /*#__PURE__*/external_react_default.a.createElement("div", menu_extends({
    className: componentClassName
  }, rest), /*#__PURE__*/external_react_default.a.createElement("button", {
    className: componentButtonClassName,
    disabled: disabled,
    id: menuButtonId,
    ref: menuButtonRef,
    onBlur: handleBlur,
    onClick: handleClick,
    "aria-expanded": isMenuShown,
    "aria-haspopup": "true"
  }, /*#__PURE__*/external_react_default.a.createElement("span", null, label)), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-menu__panel",
    "aria-expanded": isMenuShown,
    "aria-hidden": !isMenuShown
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-menu__list",
    ref: menuListRef,
    role: "listbox",
    "aria-labelledby": menuButtonId
  }, items.map(function (item, index) {
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "uhc-menu__list-item",
      key: "".concat(id, "_menuitem_").concat(index),
      onMouseDown: handleItemMouseDown,
      onClick: function onClick(event) {
        return handleItemSelect(event, item);
      },
      role: "option",
      "aria-selected": selectedItemIndex === index
    }, item);
  }))));
};
menu_Menu.propTypes = {
  buttonClassName: prop_types_default.a.string,
  className: prop_types_default.a.string,
  disabled: prop_types_default.a.bool,
  id: prop_types_default.a.string,
  items: prop_types_default.a.array,
  isBorderless: prop_types_default.a.bool,
  label: prop_types_default.a.string,
  position: prop_types_default.a.oneOf(['left', 'right']),
  onItemSelect: prop_types_default.a.func
};
menu_Menu.defaultProps = {
  disabled: false,
  isBorderless: false,
  label: 'Select',
  position: 'left'
};
/* harmony default export */ var menu = (menu_Menu);
// EXTERNAL MODULE: external "react-transition-group"
var external_react_transition_group_ = __webpack_require__(3);

// CONCATENATED MODULE: ./src/components/overlay/overlay.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/overlay/overlay.js
var overlay_excluded = ["children", "className", "isCentered", "isDark", "isShown", "shouldCloseOnClick", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"];
function overlay_extends() { overlay_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return overlay_extends.apply(this, arguments); }
function overlay_slicedToArray(arr, i) { return overlay_arrayWithHoles(arr) || overlay_iterableToArrayLimit(arr, i) || overlay_unsupportedIterableToArray(arr, i) || overlay_nonIterableRest(); }
function overlay_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function overlay_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return overlay_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return overlay_arrayLikeToArray(o, minLen); }
function overlay_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function overlay_iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function overlay_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function overlay_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = overlay_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function overlay_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var overlay_Overlay = function Overlay(props) {
  var children = props.children,
    className = props.className,
    isCentered = props.isCentered,
    isDark = props.isDark,
    isShown = props.isShown,
    shouldCloseOnClick = props.shouldCloseOnClick,
    onEnter = props.onEnter,
    onEntering = props.onEntering,
    onEntered = props.onEntered,
    onExit = props.onExit,
    onExiting = props.onExiting,
    onExited = props.onExited,
    rest = overlay_objectWithoutProperties(props, overlay_excluded);
  var _useState = Object(external_react_["useState"])(!isShown),
    _useState2 = overlay_slicedToArray(_useState, 2),
    isExited = _useState2[0],
    setIsExited = _useState2[1];
  var _useState3 = Object(external_react_["useState"])(false),
    _useState4 = overlay_slicedToArray(_useState3, 2),
    isExiting = _useState4[0],
    setIsExiting = _useState4[1];
  var componentClassNames = classnames_default()('uhc-overlay', {
    'uhc-overlay--centered': isCentered,
    'uhc-overlay--dark': isDark
  }, className);
  Object(external_react_["useEffect"])(function () {
    if (isShown) {
      setIsExited(false);
    }
  }, [isShown]);
  Object(external_react_["useEffect"])(function () {
    return function () {
      return document.body.removeEventListener('keydown', onEsc);
    };
  }, []);
  var onEsc = function onEsc(e) {
    if (e.keyCode === 27) {
      close();
    }
  };
  var close = function close() {
    setIsExiting(true);
  };
  var handleEnter = function handleEnter(node) {
    onEnter(node);
  };
  var handleEntering = function handleEntering(node) {
    document.body.addEventListener('keydown', onEsc);
    onEntering(node);
  };
  var handleEntered = function handleEntered(node) {
    onEntered(node);
  };
  var handleExit = function handleExit(node) {
    onExit(node);
  };
  var handleExiting = function handleExiting(node) {
    document.body.removeEventListener('keydown', onEsc);
    onExiting(node);
  };
  var handleExited = function handleExited(node) {
    setIsExited(true);
    setIsExiting(false);
    onExited(node);
  };
  var handleOverlayClick = function handleOverlayClick(event) {
    if (event.target !== event.currentTarget || !shouldCloseOnClick) {
      return;
    }
    close();
  };
  if (isExited) return null;
  return /*#__PURE__*/external_react_default.a.createElement(external_react_["Fragment"], null, /*#__PURE__*/external_react_default.a.createElement(external_react_transition_group_["Transition"], {
    appear: true,
    unmountOnExit: true,
    timeout: 240,
    in: isShown && !isExiting,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    onExited: handleExited
  }, function (state) {
    return /*#__PURE__*/external_react_default.a.createElement("div", overlay_extends({
      className: componentClassNames,
      onClick: handleOverlayClick,
      "data-state": state
    }, rest), typeof children === 'function' ? children({
      state: state,
      close: close
    }) : children);
  }));
};
overlay_Overlay.propTypes = {
  children: prop_types_default.a.any,
  className: prop_types_default.a.string,
  isCentered: prop_types_default.a.bool,
  isDark: prop_types_default.a.bool,
  isShown: prop_types_default.a.bool,
  shouldCloseOnClick: prop_types_default.a.bool,
  onEnter: prop_types_default.a.func,
  onEntering: prop_types_default.a.func,
  onEntered: prop_types_default.a.func,
  onExit: prop_types_default.a.func,
  onExiting: prop_types_default.a.func,
  onExited: prop_types_default.a.func
};
overlay_Overlay.defaultProps = {
  isCentered: true,
  isDark: false,
  isShown: false,
  shouldCloseOnClick: true,
  onEnter: function onEnter() {},
  onEntering: function onEntering() {},
  onEntered: function onEntered() {},
  onExit: function onExit() {},
  onExiting: function onExiting() {},
  onExited: function onExited() {}
};
/* harmony default export */ var overlay = (overlay_Overlay);
// CONCATENATED MODULE: ./src/assets/images/icons/blue-close-icon@2x.png
/* harmony default export */ var blue_close_icon_2x = ("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAyBAMAAADo5EW/AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURUdwTBlvzxpz2Rpvzxtx0htw0hpvzxluzwy/C0cAAAAHdFJOUwC2FNFGK+unwMJlAAAAqklEQVQ4y+3QMQ7CMAwFUKdqdyayVgoSe5euqAsrEzsDBygg/etDGlk2yb8BeHJiPSX+Ij9ei7UHf98/R227+eQGZ0zaJrzcIEJJN2N1gwAlCdgJIRUwUgMlDVDSgkIIKISBjTCwEQoyoUDkCDzY/edLsJBdpfzGRMEaGck7BELK0oSUpVuiKTVEU6qJxVoRi7Ui0VKKX4FdLdaAuxsMN+v3F/+6OwzyL15v1ds3Y0c0VsUAAAAASUVORK5CYII=");
// CONCATENATED MODULE: ./src/components/modal/modal.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/modal/modal.js
var modal_excluded = ["className", "isFullscreen", "isHeaderHidden", "isShown", "onCloseComplete", "onOpenComplete", "shouldCloseOnOverlayClick", "title"];
function modal_extends() { modal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return modal_extends.apply(this, arguments); }
function modal_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = modal_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function modal_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var modal_Modal = function Modal(props) {
  var className = props.className,
    isFullscreen = props.isFullscreen,
    isHeaderHidden = props.isHeaderHidden,
    isShown = props.isShown,
    onCloseComplete = props.onCloseComplete,
    onOpenComplete = props.onOpenComplete,
    shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick,
    title = props.title,
    rest = modal_objectWithoutProperties(props, modal_excluded);
  var componentClassName = classnames_default()('uhc-modal', {
    'uhc-modal--fullscreen': isFullscreen
  }, className);
  var renderChildren = function renderChildren(close) {
    var children = props.children;
    if (typeof props.children === 'function') {
      return children({
        close: close
      });
    }
    return children;
  };
  var handleEntered = function handleEntered(node) {
    document.body.classList.add('no-scroll');
    onOpenComplete(node);
  };
  var handleExited = function handleExited(node) {
    document.body.classList.remove('no-scroll');
    onCloseComplete(node);
  };
  return /*#__PURE__*/external_react_default.a.createElement(overlay, {
    isDark: true,
    isShown: isShown,
    shouldCloseOnClick: shouldCloseOnOverlayClick,
    onExited: handleExited,
    onEntered: handleEntered
  }, function (_ref) {
    var state = _ref.state,
      close = _ref.close;
    return /*#__PURE__*/external_react_default.a.createElement("div", modal_extends({
      className: componentClassName,
      "data-state": state,
      role: "dialog"
    }, rest), !isHeaderHidden && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "uhc-modal__header"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "container"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "column column-12"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "d-flex align-items-center justify-content-between"
    }, title, /*#__PURE__*/external_react_default.a.createElement("button", {
      className: "uhc-modal__close-button",
      onClick: close
    }, /*#__PURE__*/external_react_default.a.createElement("img", {
      src: blue_close_icon_2x,
      alt: ""
    }), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "visually-hidden"
    }, "Close Modal"))))))), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "uhc-modal__content",
      "data-state": state
    }, renderChildren(close)));
  });
};
modal_Modal.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  isFullscreen: prop_types_default.a.bool,
  isHeaderHidden: prop_types_default.a.bool,
  isShown: prop_types_default.a.bool,
  onCloseComplete: prop_types_default.a.func,
  onOpenComplete: prop_types_default.a.func,
  shouldCloseOnOverlayClick: prop_types_default.a.bool,
  title: prop_types_default.a.node
};
modal_Modal.defaultProps = {
  isFullscreen: false,
  isHeaderHidden: false,
  isShown: false,
  shouldCloseOnOverlayClick: true
};
/* harmony default export */ var modal = (modal_Modal);
// CONCATENATED MODULE: ./src/components/popup/popup.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/popup/popup.js
function popup_slicedToArray(arr, i) { return popup_arrayWithHoles(arr) || popup_iterableToArrayLimit(arr, i) || popup_unsupportedIterableToArray(arr, i) || popup_nonIterableRest(); }
function popup_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function popup_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return popup_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return popup_arrayLikeToArray(o, minLen); }
function popup_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function popup_iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function popup_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var popup_Popup = function Popup(props) {
  var animate = props.animate,
    children = props.children,
    className = props.className,
    delay = props.delay,
    id = props.id,
    isDarkTheme = props.isDarkTheme,
    isShown = props.isShown,
    position = props.position,
    text = props.text;
  var _useState = Object(external_react_["useState"])(false),
    _useState2 = popup_slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  Object(external_react_["useEffect"])(function () {
    if (delay > 0 && isShown) {
      setTimeout(function () {
        setIsActive(true);
      }, delay);
    }
  }, []);
  var handleChildClick = function handleChildClick() {
    setIsActive(!isActive);
  };
  var handleCloseClick = function handleCloseClick() {
    setIsActive(false);
  };
  var childrenWithAria = external_react_default.a.Children.map(children, function (child) {
    return /*#__PURE__*/external_react_default.a.cloneElement(child, {
      'aria-describedby': id,
      onClick: handleChildClick
    });
  });
  var componentClassName = classnames_default()('uhc-popup', {
    'uhc-popup--active': isActive,
    'uhc-popup--dark': isDarkTheme,
    'uhc-popup--animate': animate,
    'uhc-popup--bottom': position === 'bottom'
  }, className);
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: componentClassName
  }, childrenWithAria, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-popup__text",
    id: id,
    role: "tooltip"
  }, text, /*#__PURE__*/external_react_default.a.createElement("button", {
    className: "uhc-link-button uhc-popup__close",
    onClick: handleCloseClick
  }, /*#__PURE__*/external_react_default.a.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "visually-hidden"
  }, "Close Popup"))));
};
popup_Popup.propTypes = {
  animate: prop_types_default.a.bool,
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  delay: prop_types_default.a.number,
  id: prop_types_default.a.string,
  isDarkTheme: prop_types_default.a.bool,
  isShown: prop_types_default.a.bool,
  position: prop_types_default.a.oneOf(['top', 'bottom']),
  text: prop_types_default.a.string
};
popup_Popup.defaultProps = {
  animate: false,
  delay: 0,
  isDarkTheme: false,
  isShown: false,
  position: 'top'
};
/* harmony default export */ var popup = (popup_Popup);
// CONCATENATED MODULE: ./src/components/radio/radio.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/radio/radio.js
var radio_excluded = ["className", "label"];
function radio_extends() { radio_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return radio_extends.apply(this, arguments); }
function radio_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = radio_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function radio_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var radio_Radio = function Radio(props) {
  var className = props.className,
    label = props.label,
    rest = radio_objectWithoutProperties(props, radio_excluded);
  var componentClassName = classnames_default()('uhc-radio', className);
  return /*#__PURE__*/external_react_default.a.createElement("label", {
    className: componentClassName
  }, /*#__PURE__*/external_react_default.a.createElement("input", radio_extends({
    className: "uhc-radio__input",
    type: "radio"
  }, rest)), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-radio__visual"
  }), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-radio__label"
  }, label));
};
radio_Radio.propTypes = {
  className: prop_types_default.a.string,
  label: prop_types_default.a.any
};
/* harmony default export */ var radio_radio = (radio_Radio);
// CONCATENATED MODULE: ./src/components/radio-button/radio-button.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/radio-button/radio-button.js
function radio_button_typeof(obj) { "@babel/helpers - typeof"; return radio_button_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, radio_button_typeof(obj); }
var radio_button_excluded = ["className", "disabled", "isBlock", "label", "size", "style"];
function radio_button_extends() { radio_button_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return radio_button_extends.apply(this, arguments); }
function radio_button_defineProperty(obj, key, value) { key = radio_button_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function radio_button_toPropertyKey(arg) { var key = radio_button_toPrimitive(arg, "string"); return radio_button_typeof(key) === "symbol" ? key : String(key); }
function radio_button_toPrimitive(input, hint) { if (radio_button_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (radio_button_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function radio_button_slicedToArray(arr, i) { return radio_button_arrayWithHoles(arr) || radio_button_iterableToArrayLimit(arr, i) || radio_button_unsupportedIterableToArray(arr, i) || radio_button_nonIterableRest(); }
function radio_button_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function radio_button_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return radio_button_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return radio_button_arrayLikeToArray(o, minLen); }
function radio_button_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function radio_button_iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function radio_button_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function radio_button_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = radio_button_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function radio_button_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var radio_button_RadioButton = function RadioButton(props) {
  var className = props.className,
    disabled = props.disabled,
    isBlock = props.isBlock,
    label = props.label,
    size = props.size,
    style = props.style,
    rest = radio_button_objectWithoutProperties(props, radio_button_excluded);
  var _useState = Object(external_react_["useState"])(false),
    _useState2 = radio_button_slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var componentClassName = classnames_default()('uhc-radio-button', radio_button_defineProperty({
    'uhc-radio-button--block': isBlock,
    'uhc-radio-button--disabled': disabled,
    'uhc-radio-button--focused': isFocused
  }, "uhc-radio-button--".concat(size), true), className);
  var handleBlur = function handleBlur() {
    setIsFocused(false);
  };
  var handleFocus = function handleFocus() {
    setIsFocused(true);
  };
  return /*#__PURE__*/external_react_default.a.createElement("label", {
    className: componentClassName,
    style: style
  }, /*#__PURE__*/external_react_default.a.createElement("input", radio_button_extends({
    className: "uhc-radio-button__input",
    disabled: disabled,
    onBlur: handleBlur,
    onFocus: handleFocus,
    type: "radio"
  }, rest)), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-radio-button__visual"
  }), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-radio-button__label"
  }, label));
};
radio_button_RadioButton.propTypes = {
  className: prop_types_default.a.string,
  disabled: prop_types_default.a.bool,
  isBlock: prop_types_default.a.bool,
  label: prop_types_default.a.string,
  size: prop_types_default.a.oneOf(['small', 'medium', 'large']),
  style: prop_types_default.a.any
};
radio_button_RadioButton.defaultProps = {
  size: 'small'
};
/* harmony default export */ var radio_button = (radio_button_RadioButton);
// CONCATENATED MODULE: ./src/components/select/select.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/select/select.js
var select_excluded = ["className", "disabled", "id", "isBlock", "isBorderless", "isIFTA", "isInvalid", "label", "size", "onBlur", "onChange", "onFocus"];
function select_extends() { select_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return select_extends.apply(this, arguments); }
function select_slicedToArray(arr, i) { return select_arrayWithHoles(arr) || select_iterableToArrayLimit(arr, i) || select_unsupportedIterableToArray(arr, i) || select_nonIterableRest(); }
function select_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function select_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return select_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return select_arrayLikeToArray(o, minLen); }
function select_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function select_iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function select_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function select_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = select_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function select_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var select_Select = function Select(props) {
  var className = props.className,
    disabled = props.disabled,
    id = props.id,
    isBlock = props.isBlock,
    isBorderless = props.isBorderless,
    isIFTA = props.isIFTA,
    isInvalid = props.isInvalid,
    label = props.label,
    size = props.size,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    rest = select_objectWithoutProperties(props, select_excluded);
  var _useState = Object(external_react_["useState"])(false),
    _useState2 = select_slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var componentClassName = classnames_default()('uhc-select', {
    'uhc-select--disabled': disabled,
    'uhc-select--block': isBlock,
    'uhc-select--borderless': isBorderless,
    'uhc-select--focused': isFocused,
    'uhc-select--ifta': isIFTA,
    'uhc-select--invalid': isInvalid,
    'uhc-select--large': size === 'large'
  }, className);
  var handleFocus = function handleFocus(event) {
    if (typeof onFocus === 'function') {
      onFocus(event);
    }
    setIsFocused(true);
  };
  var handleBlur = function handleBlur(event) {
    if (typeof onBlur === 'function') {
      onBlur(event);
    }
    setIsFocused(false);
  };
  var handleChange = function handleChange(event) {
    if (typeof onChange === 'function') {
      onChange(event);
    }
  };
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: componentClassName
  }, isIFTA && /*#__PURE__*/external_react_default.a.createElement("label", {
    className: "uhc-select__label",
    htmlFor: id
  }, label), /*#__PURE__*/external_react_default.a.createElement("select", select_extends({
    className: "uhc-select__select",
    disabled: disabled,
    id: id,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }, rest)));
};
select_Select.propTypes = {
  className: prop_types_default.a.string,
  disabled: prop_types_default.a.bool,
  id: prop_types_default.a.string,
  isBlock: prop_types_default.a.bool,
  isIFTA: prop_types_default.a.bool,
  isBorderless: prop_types_default.a.bool,
  isInvalid: prop_types_default.a.bool,
  label: prop_types_default.a.string,
  size: prop_types_default.a.oneOf(['default', 'large']),
  onBlur: prop_types_default.a.func,
  onChange: prop_types_default.a.func,
  onFocus: prop_types_default.a.func
};
select_Select.defaultProps = {
  disabled: false,
  isBlock: false,
  isBorderless: false,
  isIFTA: false,
  isInvalid: false,
  size: 'default'
};
/* harmony default export */ var select_select = (select_Select);
// CONCATENATED MODULE: ./src/components/spinner/spinner.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/spinner/spinner.js



var spinner_Spinner = function Spinner(props) {
  var size = props.size;
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-spinner",
    style: {
      height: size,
      width: size
    }
  }, /*#__PURE__*/external_react_default.a.createElement("svg", {
    className: "uhc-spinner__outer-circle",
    x: "0",
    y: "0",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/external_react_default.a.createElement("circle", {
    className: "uhc-spinner__background-circle",
    cx: "75",
    cy: "75",
    r: "60"
  }), /*#__PURE__*/external_react_default.a.createElement("circle", {
    className: "uhc-spinner__inner-circle",
    cx: "75",
    cy: "75",
    r: "60"
  })));
};
spinner_Spinner.propTypes = {
  size: prop_types_default.a.number
};
spinner_Spinner.defaultProps = {
  size: 32
};
/* harmony default export */ var spinner = (spinner_Spinner);
// CONCATENATED MODULE: ./src/components/switch/switch.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/switch/switch.js
var switch_excluded = ["className", "label"];
function switch_extends() { switch_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return switch_extends.apply(this, arguments); }
function switch_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = switch_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function switch_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var switch_Switch = function Switch(props) {
  var className = props.className,
    label = props.label,
    rest = switch_objectWithoutProperties(props, switch_excluded);
  var componentClassName = classnames_default()('uhc-switch', className);
  return /*#__PURE__*/external_react_default.a.createElement("label", {
    className: componentClassName
  }, /*#__PURE__*/external_react_default.a.createElement("input", switch_extends({
    className: "uhc-switch__input",
    type: "checkbox"
  }, rest)), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-switch__slider"
  }), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-switch__label"
  }, label));
};
switch_Switch.propTypes = {
  className: prop_types_default.a.string,
  label: prop_types_default.a.string,
  onChange: prop_types_default.a.func
};
/* harmony default export */ var switch_switch = (switch_Switch);
// CONCATENATED MODULE: ./src/assets/images/icons/blue-close-icon-small@2x.png
/* harmony default export */ var blue_close_icon_small_2x = ("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkBAMAAAATLoWrAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAPUExURUdwTBpuzx1v0hpw0Rluz/Co/hQAAAAEdFJOUwCbPmRJz4+3AAAAYUlEQVQoz2NgGCyACcZQgAuZCEBoRme4IhdHCEPEBa5MxAWsjBEmhWBDZZCUISuC8lAUgbmoisDK0BSBlKEpAilDV4RNCFMjFuMxHYHFqZgewuJtzMDBFoSYAY0tOgYaAAA9ihFngAFLSwAAAABJRU5ErkJggg==");
// CONCATENATED MODULE: ./src/components/tag/tag.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/tag/tag.js
var tag_excluded = ["children", "className", "color", "isDismissable", "onDismiss"];
function tag_extends() { tag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tag_extends.apply(this, arguments); }
function tag_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = tag_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function tag_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var tag_Tag = function Tag(props) {
  var children = props.children,
    className = props.className,
    color = props.color,
    isDismissable = props.isDismissable,
    onDismiss = props.onDismiss,
    rest = tag_objectWithoutProperties(props, tag_excluded);
  var componentClassName = classnames_default()('uhc-tag', {
    'uhc-tag--blue': color === 'blue',
    'uhc-tag--gold': color === 'gold'
  }, className);
  return /*#__PURE__*/external_react_default.a.createElement("div", tag_extends({
    className: componentClassName
  }, rest), children, isDismissable && /*#__PURE__*/external_react_default.a.createElement("button", {
    className: "uhc-tag__dismiss-button",
    onClick: onDismiss
  }, /*#__PURE__*/external_react_default.a.createElement("img", {
    src: blue_close_icon_small_2x,
    alt: "",
    style: {
      width: 18,
      height: 18
    }
  }), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "visually-hidden"
  }, "Dismiss")));
};
tag_Tag.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  color: prop_types_default.a.string,
  isDismissable: prop_types_default.a.bool,
  onDismiss: prop_types_default.a.func
};
tag_Tag.defaultProps = {
  isDismissable: false
};
/* harmony default export */ var tag = (tag_Tag);
// CONCATENATED MODULE: ./src/assets/images/icons/blue-chevron-down-icon@2x.png
/* harmony default export */ var blue_chevron_down_icon_2x = ("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAyBAMAAADo5EW/AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURUdwTBpz2Rpvzxlu0CKK3Rxv1BluzyGYSrYAAAAGdFJOUwAU0bgHK02eKAAAAABzSURBVDjLY2AYBUMKhMAYrqjirMkOEAaLWQCKRFiaCYThnJaKImGWBtHCAmSgSAilQbQ4p6UpokgwqoG1ADUkCTBg0YKhAaoFiwaIFiwaIFqwaQBrwaYBrAWrBrAWRazhyKiGXQNQiyKOoGcUGE1+Qw8AAEoYGGBMBalHAAAAAElFTkSuQmCC");
// CONCATENATED MODULE: ./src/components/tile/tile.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/tile/tile.js
var tile_excluded = ["children", "className", "hiddenContent", "id", "isExpandable", "isExpanded", "isSolidColor", "showImage", "imageSrc"];
function tile_extends() { tile_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tile_extends.apply(this, arguments); }
function tile_slicedToArray(arr, i) { return tile_arrayWithHoles(arr) || tile_iterableToArrayLimit(arr, i) || tile_unsupportedIterableToArray(arr, i) || tile_nonIterableRest(); }
function tile_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tile_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tile_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tile_arrayLikeToArray(o, minLen); }
function tile_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function tile_iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function tile_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function tile_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = tile_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function tile_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var tile_Tile = function Tile(props) {
  var children = props.children,
    className = props.className,
    hiddenContent = props.hiddenContent,
    id = props.id,
    isExpandable = props.isExpandable,
    isDefaultExpanded = props.isExpanded,
    isSolidColor = props.isSolidColor,
    showImage = props.showImage,
    imageSrc = props.imageSrc,
    rest = tile_objectWithoutProperties(props, tile_excluded);
  var _useState = Object(external_react_["useState"])(isDefaultExpanded),
    _useState2 = tile_slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var buttonId = "".concat(id, "-button");
  var contentId = "".concat(id, "-content");
  var componentClassName = classnames_default()('uhc-tile', {
    'uhc-tile--solid': isSolidColor
  }, className);
  var handleClick = function handleClick() {
    setIsExpanded(function (prev) {
      return !prev;
    });
  };
  var handleKeyUp = function handleKeyUp(event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      setIsExpanded(function (prev) {
        return !prev;
      });
    }
  };
  return /*#__PURE__*/external_react_default.a.createElement("div", tile_extends({
    className: componentClassName
  }, rest), showImage && /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-tile__image"
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-tile__image-inner"
  }, /*#__PURE__*/external_react_default.a.createElement("img", {
    src: imageSrc,
    alt: ""
  }))), children && /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-tile__content"
  }, children, isExpandable && /*#__PURE__*/external_react_default.a.createElement("div", {
    hidden: !isExpanded,
    id: contentId,
    role: "region",
    "aria-labelledby": buttonId
  }, hiddenContent), isExpandable && /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "mt-20 mt-lg-30 text-center"
  }, /*#__PURE__*/external_react_default.a.createElement(LinkButton, {
    "aria-controls": contentId,
    "aria-disabled": "false",
    "aria-expanded": isExpanded,
    onClick: handleClick,
    onKeyUp: handleKeyUp
  }, /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "d-flex align-items-center gap-5"
  }, /*#__PURE__*/external_react_default.a.createElement("span", null, "Show ", isExpanded ? 'less' : 'more'), /*#__PURE__*/external_react_default.a.createElement("img", {
    src: blue_chevron_down_icon_2x,
    alt: "",
    style: {
      width: 24,
      height: 24,
      transform: isExpanded ? 'scaleY(-1)' : 'scaleY(1)'
    }
  }))))));
};
tile_Tile.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  hiddenContent: prop_types_default.a.node,
  id: prop_types_default.a.string,
  imageSrc: prop_types_default.a.string,
  isExpandable: prop_types_default.a.bool,
  isExpanded: prop_types_default.a.bool,
  isSolidColor: prop_types_default.a.bool,
  showImage: prop_types_default.a.bool
};
/* harmony default export */ var tile = (tile_Tile);
// CONCATENATED MODULE: ./src/components/toggle/toggle.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/toggle/toggle.js
var toggle_excluded = ["className", "disabled", "label", "selected"],
  toggle_excluded2 = ["className", "disabled", "label", "options", "onChange"];
function toggle_extends() { toggle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return toggle_extends.apply(this, arguments); }
function toggle_slicedToArray(arr, i) { return toggle_arrayWithHoles(arr) || toggle_iterableToArrayLimit(arr, i) || toggle_unsupportedIterableToArray(arr, i) || toggle_nonIterableRest(); }
function toggle_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function toggle_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return toggle_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return toggle_arrayLikeToArray(o, minLen); }
function toggle_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function toggle_iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function toggle_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function toggle_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = toggle_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function toggle_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var ToggleOption = /*#__PURE__*/Object(external_react_["forwardRef"])(function (props, ref) {
  var className = props.className,
    disabled = props.disabled,
    label = props.label,
    selected = props.selected,
    rest = toggle_objectWithoutProperties(props, toggle_excluded);
  var _useState = Object(external_react_["useState"])(false),
    _useState2 = toggle_slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var componentClassName = classnames_default()('uhc-toggle__option', {
    'uhc-toggle__option--disabled': disabled,
    'uhc-toggle__option--focused': isFocused
  }, className);
  var handleBlur = function handleBlur() {
    setIsFocused(false);
  };
  var handleFocus = function handleFocus() {
    setIsFocused(true);
  };
  return /*#__PURE__*/external_react_default.a.createElement("button", toggle_extends({
    className: componentClassName,
    disabled: disabled,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: ref,
    role: "tab",
    "aria-selected": selected
  }, rest), /*#__PURE__*/external_react_default.a.createElement("span", {
    className: "uhc-toggle__option-label"
  }, label));
});
ToggleOption.displayName = 'Toggle';
ToggleOption.propTypes = {
  className: prop_types_default.a.string,
  disabled: prop_types_default.a.bool,
  label: prop_types_default.a.string,
  selected: prop_types_default.a.bool
};
ToggleOption.defaultProps = {
  disabled: false,
  selected: false
};
var toggle_Toggle = function Toggle(props) {
  var className = props.className,
    disabled = props.disabled,
    label = props.label,
    options = props.options,
    onChange = props.onChange,
    rest = toggle_objectWithoutProperties(props, toggle_excluded2);
  var componentClassName = classnames_default()('uhc-toggle', {
    'uhc-toggle--disabled': disabled
  }, className);
  var optionsLength = options.length;
  var _useState3 = Object(external_react_["useState"])(0),
    _useState4 = toggle_slicedToArray(_useState3, 2),
    selectedIndex = _useState4[0],
    setSelectedIndex = _useState4[1];
  var _useState5 = Object(external_react_["useState"])([]),
    _useState6 = toggle_slicedToArray(_useState5, 2),
    elRefs = _useState6[0],
    setElRefs = _useState6[1];
  Object(external_react_["useEffect"])(function () {
    setElRefs(function (elRefs) {
      return Array(optionsLength).fill().map(function (_, i) {
        return elRefs[i] || /*#__PURE__*/Object(external_react_["createRef"])();
      });
    });
  }, [optionsLength]);
  var handleClick = function handleClick(index) {
    setSelectedIndex(index);
    onChange(index);
  };
  var handleKeyUp = function handleKeyUp(event) {
    switch (event.which) {
      case 35:
        focusLastTab();
        break;
      case 36:
        focusFirstTab();
        break;
      case 37:
        focusPrevTab();
        break;
      case 39:
        focusNextTab();
        break;
    }
  };
  var getCurrentFocusedIndex = function getCurrentFocusedIndex() {
    var currentFocusedEl = elRefs.find(function (x) {
      return x.current === document.activeElement;
    });
    return elRefs.indexOf(currentFocusedEl);
  };
  var focusPrevTab = function focusPrevTab() {
    var currentFocusedIndex = getCurrentFocusedIndex();
    if (elRefs[currentFocusedIndex - 1]) {
      elRefs[currentFocusedIndex - 1].current.focus();
    } else {
      elRefs[optionsLength - 1].current.focus();
    }
  };
  var focusNextTab = function focusNextTab() {
    var currentFocusedIndex = getCurrentFocusedIndex();
    if (elRefs[currentFocusedIndex + 1]) {
      elRefs[currentFocusedIndex + 1].current.focus();
    } else {
      elRefs[0].current.focus();
    }
  };
  var focusFirstTab = function focusFirstTab() {
    elRefs[0].current.focus();
  };
  var focusLastTab = function focusLastTab() {
    elRefs[optionsLength - 1].current.focus();
  };
  return /*#__PURE__*/external_react_default.a.createElement("div", toggle_extends({
    className: componentClassName,
    role: "tablist",
    "aria-label": label
  }, rest), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-toggle__inner"
  }, options.map(function (option, index) {
    return /*#__PURE__*/external_react_default.a.createElement(ToggleOption, {
      disabled: disabled,
      key: index,
      label: option,
      ref: elRefs[index],
      selected: index === selectedIndex,
      onClick: function onClick() {
        return handleClick(index);
      },
      onKeyUp: handleKeyUp,
      tabIndex: index === selectedIndex ? null : -1
    });
  }), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "uhc-toggle__slider",
    style: {
      transform: "translateX(".concat(selectedIndex * 100, "%)"),
      width: "".concat(100 / options.length, "%")
    }
  })));
};
toggle_Toggle.propTypes = {
  className: prop_types_default.a.string,
  disabled: prop_types_default.a.bool,
  label: prop_types_default.a.string,
  options: prop_types_default.a.arrayOf(prop_types_default.a.string),
  onChange: prop_types_default.a.func
};
toggle_Toggle.defaultProps = {
  disabled: false,
  options: []
};
/* harmony default export */ var toggle = (toggle_Toggle);
// CONCATENATED MODULE: ./src/components/tooltip/tooltip.scss
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/tooltip/tooltip.js
var tooltip_excluded = ["children", "className", "id", "text"];
function tooltip_extends() { tooltip_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tooltip_extends.apply(this, arguments); }
function tooltip_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = tooltip_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function tooltip_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var tooltip_Tooltip = function Tooltip(props) {
  var children = props.children,
    className = props.className,
    id = props.id,
    text = props.text,
    rest = tooltip_objectWithoutProperties(props, tooltip_excluded);
  var componentClassName = classnames_default()('uhc-tooltip', {}, className);
  var childrenWithAria = external_react_default.a.Children.map(children, function (child) {
    return /*#__PURE__*/external_react_default.a.cloneElement(child, {
      'aria-describedby': id
    });
  });
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: componentClassName
  }, childrenWithAria, /*#__PURE__*/external_react_default.a.createElement("div", tooltip_extends({
    className: "uhc-tooltip__text",
    id: id,
    role: "tooltip"
  }, rest), text));
};
tooltip_Tooltip.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  id: prop_types_default.a.string,
  text: prop_types_default.a.string
};
tooltip_Tooltip.defaultProps = {};
/* harmony default export */ var tooltip = (tooltip_Tooltip);
// CONCATENATED MODULE: ./src/index.js

























/***/ })
/******/ ]);
});